module.exports = __webpack_public_path__ + "5e574dd7059b16dc3238927aa78f705b.MP3";